// Benepack OMS · enum short-name → proto enum-name codec
// SSOT: api/proto/master/v1/master.proto + api/proto/trade/v1/trade.proto enum 定义
//
// 背景 (WP-06 · v7.5.0 gateway protojson 根治后归一 · Jason 2026-05-29):
//   gateway controller DecodeJSON 已从标准 encoding/json 换成 protojson.Unmarshal
//   (commit 199108b · v7.5.0)。request body 绑 protobuf message 时:
//     - protojson 对 enum 字段【既认 integer 也认 proto 枚举值名 string】(canonical form)。
//     - 旧 encoding/json 只认 integer (短名/名 string 全 400) → 这是 rc3.2 发 int 的根因。
//
//   ★ 本 codec 之前是 "短名 → proto int32" 的 stopgap (v7.5.0 前 gateway 只认 int)。
//     v7.5.0 protojson 落地后归一为【发 canonical proto 枚举值名 string】:
//       - 标准 protojson 形态 · 不再依赖 proto enum value 的魔法数字 (其值不保证连续 ·
//         renumber 时按名发更稳健)。
//       - 仍需 codec: protojson 不认前端短名 ("active") · 只认 proto 值名
//         ("CUSTOMER_STATUS_ACTIVE") 或 int · 故 form/zod 的 UI 友好短名 → proto 名 的
//         映射层必须保留 · 只是输出从 int 改为 name string。
//
// 设计:
//   - 显式 dict (短名 → proto 枚举值名 · 1:1 · 与 proto 定义逐值对齐)
//   - mapEnum 未知短名抛错 (不静默 fallback UNSPECIFIED → backend 422 "must not be UNSPECIFIED")
//   - key 用 web/src/types/master.ts 的短名 union (codegen SSOT)

// ===== Kind / Status → proto 枚举值名 显式映射 (1:1 · master.proto) =====

/** CustomerKind · CUSTOMER_KIND_* (master.proto:59) */
export const CustomerKindToProto: Record<string, string> = {
  pharma_manufacturer: 'CUSTOMER_KIND_PHARMA_MANUFACTURER',
  device_manufacturer: 'CUSTOMER_KIND_DEVICE_MANUFACTURER',
  distributor: 'CUSTOMER_KIND_DISTRIBUTOR',
  health_food: 'CUSTOMER_KIND_HEALTH_FOOD',
  other: 'CUSTOMER_KIND_OTHER',
};

/** CustomerStatus · CUSTOMER_STATUS_* (master.proto:69) */
export const CustomerStatusToProto: Record<string, string> = {
  active: 'CUSTOMER_STATUS_ACTIVE',
  paused: 'CUSTOMER_STATUS_PAUSED',
  disabled: 'CUSTOMER_STATUS_DISABLED',
};

/** SupplierKind · SUPPLIER_KIND_* (master.proto:77) */
export const SupplierKindToProto: Record<string, string> = {
  factory: 'SUPPLIER_KIND_FACTORY',
  agent: 'SUPPLIER_KIND_AGENT',
  trader: 'SUPPLIER_KIND_TRADER',
  other: 'SUPPLIER_KIND_OTHER',
};

/** SupplierStatus · SUPPLIER_STATUS_* (master.proto:86) */
export const SupplierStatusToProto: Record<string, string> = {
  active: 'SUPPLIER_STATUS_ACTIVE',
  paused: 'SUPPLIER_STATUS_PAUSED',
  disabled: 'SUPPLIER_STATUS_DISABLED',
};

/** ProductStatus · PRODUCT_STATUS_* (master.proto:130) */
export const ProductStatusToProto: Record<string, string> = {
  active: 'PRODUCT_STATUS_ACTIVE',
  paused: 'PRODUCT_STATUS_PAUSED',
  disabled: 'PRODUCT_STATUS_DISABLED',
};

/** SkuStatus · SKU_STATUS_* (master.proto:138) */
export const SkuStatusToProto: Record<string, string> = {
  active: 'SKU_STATUS_ACTIVE',
  paused: 'SKU_STATUS_PAUSED',
  disabled: 'SKU_STATUS_DISABLED',
};

/** PriceListKind · PRICE_LIST_KIND_* (master.proto:160) */
export const PriceListKindToProto: Record<string, string> = {
  sales: 'PRICE_LIST_KIND_SALES',
  purchase: 'PRICE_LIST_KIND_PURCHASE',
};

/** PriceListStatus · PRICE_LIST_STATUS_* (master.proto:167) */
export const PriceListStatusToProto: Record<string, string> = {
  draft: 'PRICE_LIST_STATUS_DRAFT',
  active: 'PRICE_LIST_STATUS_ACTIVE',
  deprecated: 'PRICE_LIST_STATUS_DEPRECATED',
};

// ===== master · CustomerDiscount enums (P2-1 定价三层接线 · master.proto:147/154) =====

/** DiscountType · DISCOUNT_TYPE_* (master.proto:147 · percent 0.0500=5% / absolute 单价直减) */
export const DiscountTypeToProto: Record<string, string> = {
  percent: 'DISCOUNT_TYPE_PERCENT',
  absolute: 'DISCOUNT_TYPE_ABSOLUTE',
};

/** CustomerDiscountStatus · CUSTOMER_DISCOUNT_STATUS_* (master.proto:154 · disabled terminal) */
export const CustomerDiscountStatusToProto: Record<string, string> = {
  active: 'CUSTOMER_DISCOUNT_STATUS_ACTIVE',
  disabled: 'CUSTOMER_DISCOUNT_STATUS_DISABLED',
};

// ===== master · ContactPerson enums (GL-13 contacts-slice · master.proto:94/109) =====

/**
 * ContactOwnerKind · CONTACT_OWNER_KIND_* (master.proto:94 · create/update owner_kind 提交用)
 * 注: UNSPECIFIED 不暴露 (下游 contactOwnerKindFromProto UNSPECIFIED → 422)。
 *     owner_kind 由 detail 上下文注入 (customer/supplier detail tab) · 表单不可改。
 */
export const ContactOwnerKindToProto: Record<string, string> = {
  customer: 'CONTACT_OWNER_KIND_CUSTOMER',
  supplier: 'CONTACT_OWNER_KIND_SUPPLIER',
};

/**
 * ContactStatus · CONTACT_STATUS_* (master.proto:109 · create/update status 提交用)
 * 注: UNSPECIFIED 不暴露 (下游 contactStatusFromProto UNSPECIFIED → 422 · create 也必须显式送 ·
 *     master usecase "" 默认 active 在 grpc 层之前已被挡 · 故前端 create 恒送 active)。
 *     email_status 是另一枚举 (只读 · platform 回调维护) · 前端永不提交 · 无 codec。
 */
export const ContactStatusToProto: Record<string, string> = {
  active: 'CONTACT_STATUS_ACTIVE',
  disabled: 'CONTACT_STATUS_DISABLED',
};

// ===== trade · SalesOrder enums (D-4.2a · trade.proto:55/71) =====
//
// 注: SO 一期无 create form (SO 由 quote→CustomerAccept 派生 · 无手工 Create 端点) ·
//     Confirm/Cancel/拆单 action 也不传 enum (只 path id + 可选 reason)。
//     这两个 dict 当前未被 adapter 消费 · 仅为 (a) list filter 预留 (gateway ListSalesOrders
//     一期未解析 status filter · 见 readiness §1) (b) proto 真值落档 (短名↔proto 名 单源)。
//     若 SO 加 create/filter 提交 enum · 直接复用本 dict (protojson 发 proto 名)。

/** SoStatus · SO_STATUS_* (trade.proto:55 · 12 值) */
export const SoStatusToProto: Record<string, string> = {
  draft: 'SO_STATUS_DRAFT',
  confirmed: 'SO_STATUS_CONFIRMED',
  splitting: 'SO_STATUS_SPLITTING',
  po_issued: 'SO_STATUS_PO_ISSUED',
  partial_received: 'SO_STATUS_PARTIAL_RECEIVED',
  all_received: 'SO_STATUS_ALL_RECEIVED',
  partial_shipped: 'SO_STATUS_PARTIAL_SHIPPED',
  shipped: 'SO_STATUS_SHIPPED',
  delivered: 'SO_STATUS_DELIVERED',
  invoiced: 'SO_STATUS_INVOICED',
  closed: 'SO_STATUS_CLOSED',
  cancelled: 'SO_STATUS_CANCELLED',
};

/** SoLineStatus · SO_LINE_STATUS_* (trade.proto:71 · 7 值) */
export const SoLineStatusToProto: Record<string, string> = {
  pending: 'SO_LINE_STATUS_PENDING',
  split: 'SO_LINE_STATUS_SPLIT',
  partial_received: 'SO_LINE_STATUS_PARTIAL_RECEIVED',
  all_received: 'SO_LINE_STATUS_ALL_RECEIVED',
  partial_shipped: 'SO_LINE_STATUS_PARTIAL_SHIPPED',
  all_shipped: 'SO_LINE_STATUS_ALL_SHIPPED',
  cancelled: 'SO_LINE_STATUS_CANCELLED',
};

// ===== trade · PurchaseOrder enums (D-4.2b-2 · trade.proto:90/106/116) =====
//
// 注: PO action (submit-approval/send/resend/mark-acknowledged/cancel) 均不传 enum (只 path id +
//     cancel reason StringValue)。这三个 dict 当前仅为 (a) list status/approval_state filter 预留
//     (gateway ListPurchaseOrders 一期未解析 filter · readiness §3.1) (b) proto 真值落档。
//     若 PO 加 filter 提交 enum · 直接复用本 dict (protojson 发 proto 名)。

/** PoStatus · PO_STATUS_* (trade.proto:90 · 12 值) */
export const PoStatusToProto: Record<string, string> = {
  draft: 'PO_STATUS_DRAFT',
  pending_approval: 'PO_STATUS_PENDING_APPROVAL',
  in_approval: 'PO_STATUS_IN_APPROVAL',
  approved: 'PO_STATUS_APPROVED',
  pending_send: 'PO_STATUS_PENDING_SEND',
  sent: 'PO_STATUS_SENT',
  acknowledged: 'PO_STATUS_ACKNOWLEDGED',
  partial_received: 'PO_STATUS_PARTIAL_RECEIVED',
  received: 'PO_STATUS_RECEIVED',
  closed: 'PO_STATUS_CLOSED',
  rejected: 'PO_STATUS_REJECTED',
  cancelled: 'PO_STATUS_CANCELLED',
};

/** PoApprovalState · PO_APPROVAL_STATE_* (trade.proto:116) */
export const PoApprovalStateToProto: Record<string, string> = {
  not_started: 'PO_APPROVAL_STATE_NOT_STARTED',
  in_oms: 'PO_APPROVAL_STATE_IN_OMS',
  in_feishu: 'PO_APPROVAL_STATE_IN_FEISHU',
  approved: 'PO_APPROVAL_STATE_APPROVED',
  rejected: 'PO_APPROVAL_STATE_REJECTED',
};

/** PoLineStatus · PO_LINE_STATUS_* (trade.proto:106 · 6 值) */
export const PoLineStatusToProto: Record<string, string> = {
  pending: 'PO_LINE_STATUS_PENDING',
  sent: 'PO_LINE_STATUS_SENT',
  acknowledged: 'PO_LINE_STATUS_ACKNOWLEDGED',
  partial_received: 'PO_LINE_STATUS_PARTIAL_RECEIVED',
  received: 'PO_LINE_STATUS_RECEIVED',
  cancelled: 'PO_LINE_STATUS_CANCELLED',
};

// ===== finance · InvoiceRegister enum (WP-18 · finance.proto:89) =====

/** InvoiceKind · INVOICE_KIND_* (finance.proto:89 · 4 值 · create form invoice_kind 提交用) */
export const InvoiceKindToProto: Record<string, string> = {
  vat_special: 'INVOICE_KIND_VAT_SPECIAL',
  vat_normal: 'INVOICE_KIND_VAT_NORMAL',
  e_invoice: 'INVOICE_KIND_E_INVOICE',
  red: 'INVOICE_KIND_RED',
};

// ===== identity · User enum (前端补面② · identity.proto:UserStatus) =====

/**
 * UserStatus · USER_STATUS_* (identity.proto · 4 值 · create/update form status 提交用)
 * 注: UNSPECIFIED 不暴露 (下游 usecase UNSPECIFIED → 422)。response 侧 gateway 把 LOCKED/DISABLED
 *     都映射成 Active=false (同 Customer paused/disabled 合并 · 列表不可细分)。
 */
export const UserStatusToProto: Record<string, string> = {
  active: 'USER_STATUS_ACTIVE',
  locked: 'USER_STATUS_LOCKED',
  disabled: 'USER_STATUS_DISABLED',
};

/**
 * mapEnum · 必填 enum 短名 → proto 枚举值名 string (create 用 · 值必存在)
 * 未知短名抛错 · 不静默发 UNSPECIFIED (→ backend 422)
 */
export function mapEnum(dict: Record<string, string>, v: string): string {
  const n = dict[v];
  if (n === undefined) {
    throw new Error(`enum-codec: 未知枚举短名 "${v}" · 检查 proto enum 与 codec dict 是否对齐`);
  }
  return n;
}

/**
 * mapEnumOpt · 可选 enum 短名 → proto 枚举值名 string | undefined (update Partial 用)
 * undefined/null/'' → undefined (字段省略 · 不覆盖 backend) · 非空未知短名仍抛错
 */
export function mapEnumOpt(
  dict: Record<string, string>,
  v: string | undefined | null,
): string | undefined {
  if (v === undefined || v === null || v === '') return undefined;
  return mapEnum(dict, v);
}
